import { AvatarGroupPassThroughOptions } from "primereact/avatargroup";

export const avatargroup: AvatarGroupPassThroughOptions = {
    root: () => 'flex items-center'
}
